import { ReactComponent as BackIcon } from "../Assets/generic/back.svg";
import { ReactComponent as EmailIcon } from "../Assets/generic/email.svg";
import { ReactComponent as LinkedinIcon } from "../Assets/generic/linkedin.svg";
import { ReactComponent as RefreshIcon } from "../Assets/generic/refresh.svg";
import { useLocation, Link } from "react-router-dom";

interface NavProps {
  changeColorsCallBack: () => void;
}

const TopNav = ({ changeColorsCallBack }: NavProps) => {
  const location = useLocation();
  const isNotHomePage = location.pathname !== "/";
  const isPortfolioPage = location.pathname.startsWith("/portfolio");

  // Split by "/" to see how deep the path is
  const pathParts = location.pathname.split("/").filter(Boolean);
  const isPortfolioDetail = isPortfolioPage && pathParts.length > 1;

  return (
    <nav className="toolbar">
      <div className="tb-left">
        {isNotHomePage && (
          <div className="back-home">
            {isPortfolioDetail ? (
              <>
              {/* <Link to="/portfolio#works">
                <BackIcon /> <span>Portfolio</span>
              </Link> */}
              </>
            ) : (
              <Link to="/">
                <BackIcon /> <span>Home</span>
              </Link>
            )}
          </div>
        )}

        <div className="email-icon-wrapper">
          <a href="mailto:theumabrian@gmail.com?Subject=Hello...">
            <EmailIcon />
          </a>
          <span className="email-tooltip">theumabrian@gmail.com</span>
        </div>
        <div>
          <a
            href="https://www.linkedin.com/in/briantheuma/"
            rel="noopener noreferrer"
            target="_blank"
          >
            <LinkedinIcon />
          </a>
        </div>
      </div>

      <div className="tb-right">
        <div className="change-color" onClick={changeColorsCallBack}>
          <span>change color</span>
          <RefreshIcon />
        </div>
      </div>
    </nav>
  );
};

export default TopNav;